import { apiClient } from './api'

export default {
  listByReceipt(receiptId) {
    return apiClient.get(`/receipts/${receiptId}/image-assets`)
  },
  receiptAssetImageUrl(receiptId, assetId) {
    return `${apiClient.defaults.baseURL}/receipts/${receiptId}/image-assets/${encodeURIComponent(assetId)}/image`
  },
  adminStats() {
    return apiClient.get('/admin/receipt-image-assets/stats')
  },
  adminList(params = {}) {
    return apiClient.get('/admin/receipt-image-assets', { params })
  },
  adminAssetImageUrl(assetId) {
    return `${apiClient.defaults.baseURL}/admin/receipt-image-assets/${encodeURIComponent(assetId)}/image`
  },
}
